import { logger } from '@adornis/base/logging.js';
import { BHDialogFreeFormMails } from '@adornis/bh-mails/client/bh-dialog-free-form-mails.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import '@adornis/buchungsheld-theme/components/tr-mail-editor.js';
import '@adornis/chemistry/elements/components/x-button.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { catchError, map, of } from 'rxjs';
import type { Match } from '../entities/match.js';

/*
 * @element matching-dialog-matches-free-form-mails
 */
@customElement('matching-dialog-matches-free-form-mails')
export class MatchingDialogMatchesFreeFormMails extends BHDialogFreeFormMails {
  @property({ attribute: false }) protected allMatches?: Match[];

  static override get element_name() {
    return 'matching-dialog-matches-free-form-mails';
  }

  protected override content() {
    return html`
      <x-flex space="lg">
        ${this._mailAddressDisplay()}
        <tr-mail-editor .value=${this._mailTemplate}></tr-mail-editor>
        <x-flex horizontal space-between end space="sm">
          <x-button mode="outline" @click=${() => this.close()}> Abbrechen </x-button>
          <x-button icon="send" @click=${() => this._sendMails()}> Mail senden </x-button>
        </x-flex>
      </x-flex>
    `;
  }

  override async _sendMails() {
    if (!this.mailAddresses?.length) return;

    if (!this.mailSendOperation)
      throw new Error('Cannot happen as this is catched in connectedCallback (bh-dialog-free-form-mails)');
    try {
      const result = await TrDialog.waitFor<string | null>(
        this.mailSendOperation
          .bind(null)(
            (this.allMatches ?? []).map(m => m._id),
            this._mailTemplate,
          )()
          .pipe(
            map(
              numMailsSent =>
                `${numMailsSent} Mail${+numMailsSent > 1 ? 's' : ''} wurde${
                  +numMailsSent > 1 ? 'n' : ''
                } bereits versandt.`,
            ),
            // TODO catch this in TrDialog.waitFor and do proper error handling
            catchError(err => {
              logger.error({ err });
              void TrDialog.alert(
                'Es gab ein Problem beim Versenden der Freitext-Mails. Bitte versuchen Sie es später erneut.',
              );
              return of(null);
            }),
          ),
      );
      if (result) void XSnackbar.show('Mails wurden erfolgreich versandt.');
      this.close();
    } catch (err) {
      logger.error({ err });
      void TrDialog.alert(
        'Es gab ein Problem beim Versenden der Freitext-Mails. Bitte versuchen Sie es später erneut.',
      );
    }
  }
}
